"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../api/utils");

var _reactRouterDom = require("react-router-dom");

var _Container = _interopRequireDefault(require("../components/components/Container"));

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var NoChild = function NoChild() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-screen flex items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-lg font-bold"
  }, "OOPS!!! Something went awry!"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-right"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "/auth"
  }, "to directory"))));
};

var NoAuthority = function NoAuthority() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-screen flex items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-lg font-bold"
  }, "OOPS!!! You do not have the authority!"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-right"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "/auth"
  }, "to directory"))));
};

var _default = function _default(Component) {
  var AmsManager = function AmsManager(_ref) {
    var _ref$params = _ref.params,
        params = _ref$params === void 0 ? {} : _ref$params,
        children = _ref.children,
        _ref$showHeaders = _ref.showHeaders,
        showHeaders = _ref$showHeaders === void 0 ? true : _ref$showHeaders,
        className = _ref.className,
        props = _objectWithoutProperties(_ref, ["params", "children", "showHeaders", "className"]);

    var action = params.action,
        location = (0, _reactRouterDom.useLocation)();
    var requiredAuth = -1;

    var Children = _react["default"].Children.toArray(children).filter(function (_ref2) {
      var props = _ref2.props;
      return !("amsAction" in props) || props.amsAction === action;
    }).map(function (child) {
      requiredAuth = Math.max(requiredAuth, (0, _lodash["default"])(child, ["props", "authLevel"], -1));
      return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread(_objectSpread(_objectSpread({}, props), params), {}, {
        location: location,
        showHeaders: (0, _lodash["default"])(child, ["props", "showHeaders"], showHeaders),
        project: _utils.Config.PROJECT_NAME
      }));
    });

    if (!action || action === "directory") {
      Children = _react["default"].Children.toArray(children).filter(function (_ref3) {
        var props = _ref3.props;
        return !("amsAction" in props) || props.amsAction === "directory";
      }).map(function (child) {
        return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread(_objectSpread(_objectSpread({}, props), params), {}, {
          location: location,
          showHeaders: (0, _lodash["default"])(child, ["props", "showHeaders"], showHeaders),
          children: children,
          project: _utils.Config.PROJECT_NAME
        }));
      });
    } else if (!props.user.authed && requiredAuth > -1) {
      Children = _react["default"].Children.toArray(children).filter(function (_ref4) {
        var props = _ref4.props;
        return !("amsAction" in props) || props.amsAction === "login";
      }).map(function (child) {
        return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread(_objectSpread(_objectSpread({}, props), params), {}, {
          location: location,
          showHeaders: (0, _lodash["default"])(child, ["props", "showHeaders"], showHeaders),
          project: _utils.Config.PROJECT_NAME
        }));
      });
    } else if (props.user.authed && props.user.authLevel < requiredAuth) {
      Children = [].concat(_toConsumableArray(_react["default"].Children.toArray(children).filter(function (_ref5) {
        var props = _ref5.props;
        return !("amsAction" in props);
      }).map(function (child) {
        return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread(_objectSpread(_objectSpread({}, props), params), {}, {
          location: location,
          showHeaders: (0, _lodash["default"])(child, ["props", "showHeaders"], showHeaders),
          project: _utils.Config.PROJECT_NAME
        }));
      })), [/*#__PURE__*/_react["default"].createElement(NoAuthority, {
        key: "no-auth"
      })]);
    }

    if (!Children.length) {
      Children = /*#__PURE__*/_react["default"].createElement(NoChild, null);
    }

    return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, params, {
      className: className,
      showHeaders: showHeaders,
      project: _utils.Config.PROJECT_NAME
    }), Children);
  };

  return AmsManager;
};

exports["default"] = _default;